const Data = [
    {
        name: "Shubham Agrawal",
        position: "Finance Head",
        imageUrl: "/assets/images/members/Heads21/Shubham Agrawal.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Mayank Agrawal",
        position: "Finance Head",
        imageUrl: "/assets/images/members/Heads21/Mayank Agrawal.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },
    {
        name: "Aditya Mallick",
        position: "Finance Head",
        imageUrl: "/assets/images/members/Heads21/Aditya Mallick.jpg",
        facebookLink: "https://www.facebook.com/gyws.iitkgp",
        linkedinLink: "https://www.linkedin.com/company/gopali-youth-welfare-society/mycompany/",
        email: "gywsociety@gmail.com"
    },

]

export default Data;